import { render } from "./WhyUs.vue?vue&type=template&id=15e8c6f3&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"

import "./WhyUs.vue?vue&type=style&index=0&id=15e8c6f3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15e8c6f3"

export default script